import React from "react";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { Link as RouterLink } from "react-router-dom";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Grid, Button, Typography, Link, IconButton, InputAdornment, CircularProgress, DialogTitle, DialogActions, DialogContent } from "@material-ui/core";

import { authenticateUser, resendVerfication, verifyOtp, resendOtp } from "../../redux/auth.action";
import { doNotification, closeNotification } from "../../../shared/component/notifier";
import DialogBox from '../../../shared/component/dialogBox';
import FormInput from "../../../shared/component/formInput";

import ChangePassword from '../../../account/changePassword/component/';
import SuccessReverifyModal from "./successReverifyModal";
import OtpForm from "../otp";

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                username: "",
                password: ""
            },
            formErrors: {},
            requestId: '',
            actionType: '',
            dialogOpen: false,
            showPassword: false,
            onSuccessDialogOpen: false,
            showResendVerificationBlock: false,
        };

        this.handleModal = this.handleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVerifyOtp = this.handleVerifyOtp.bind(this);
        this.handleResendOtp = this.handleResendOtp.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleResendVerification = this.handleResendVerification.bind(this);
        this.handleNavigateToDashboard = this.handleNavigateToDashboard.bind(this);
        this.handleOnSuccessDialogClose = this.handleOnSuccessDialogClose.bind(this);
        this.handleTogglePasswordVisibility = this.handleTogglePasswordVisibility.bind(this);
        this.handleHideResendVerificationBlock = this.handleHideResendVerificationBlock.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { formData } = this.state;
        const { authError, authUser, reVerifyError, reVerifySuccess, verifyOtpError, enqueueSnackbar, closeSnackbar } = this.props;

        if (authUser && prevProps.authUser !== authUser) {
            if (authUser.otpIsRequired && !authUser.tokenData) {
                this.setState({ requestId: authUser.requestId }, () => this.handleModal('Enter OTP'));
                return;
            }
            if (authUser.isFirstLogin) {
                this.handleModal('Change Password');
                return;
            }
            this.handleDialogClose();
            this.handleNavigateToDashboard();
        }

        if (reVerifySuccess && prevProps.reVerifySuccess !== reVerifySuccess) {
            this.setState({ onSuccessDialogOpen: true });
        }

        if (reVerifyError && prevProps.reVerifyError !== reVerifyError) {
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, reVerifyError, "error");
        }

        if (verifyOtpError && prevProps.verifyOtpError !== verifyOtpError) {
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, verifyOtpError, "error");
        }

        if (authError && prevProps.authError !== authError) {
            if (authError.toLowerCase().indexOf("verify email") > -1) {
                this.setState({ showResendVerificationBlock: true });
            }
            else {
                formData["password"] = "";
                this.setState({ formData });
            }

            this.notify = doNotification(enqueueSnackbar, closeSnackbar, authError, "error");
        }
    }

    handleTogglePasswordVisibility() {
        this.setState(({ showPassword }) => ({ showPassword: !showPassword }));
    }

    handleNavigateToDashboard() {
        const { history } = this.props;
        history.push("/dashboard");
    }

    handleModal(action) {
        let width = 'sm';

        if (action === 'Enter OTP') {
            width = 'xs';
        }
        this.setState({
            dialogOpen: true,
            dialogWidth: width,
            actionType: action,
        });
    }

    handleChange(event) {
        const { isLoading, resendVerficationLoading } = this.props;

        if (isLoading || resendVerficationLoading) {
            return;
        }
        const { formData, formErrors } = this.state;
        const { name, value } = event.target;
        formData[name] = value;
        delete formErrors[name];
        this.setState({ formData, formErrors });
    }

    isValid(fields) {
        let { formData, formErrors } = this.state;
        formErrors = {};

        for (const field of fields) {
            if (field === "username") {
                !formData[field] && (formErrors[field] = "Username is required");
            }

            if (field === "password") {
                !formData[field] && (formErrors[field] = "Password is required");
            }
        }
        this.setState({ formErrors });
        return Object.keys(formErrors).length === 0;
    }

    handleHideResendVerificationBlock() {
        const { formData } = this.state;
        formData.password = "";
        this.setState({ showResendVerificationBlock: false, formData });
    }

    handleResendVerification() {
        const { resendVerfication, closeSnackbar } = this.props;
        const { formData } = this.state;
        const isValid = this.isValid(["username", "password"]);

        if (!isValid) {
            return;
        }
        this.notify = closeNotification(this.notify, closeSnackbar);
        resendVerfication(formData);
    }

    handleVerifyOtp(data) {
        const { verifyOtp } = this.props;
        const { requestId } = this.state;
        verifyOtp({ code: data.otp, requestId })
    }

    handleResendOtp() {
        const { resendOtp } = this.props;
        const { requestId } = this.state;
        resendOtp({ feature: 0, requestId });
    }

    handleLogin(event) {
        event.preventDefault();
        const { authenticateUser, closeSnackbar } = this.props;
        const { formData } = this.state;
        const isValid = this.isValid(["username", "password"]);

        if (!isValid) {
            return;
        }
        this.notify = closeNotification(this.notify, closeSnackbar);
        authenticateUser(formData);
    }

    handleOnSuccessDialogClose() {
        const { formData } = this.state;
        formData.password = "";
        this.setState({
            formData,
            onSuccessDialogOpen: false,
            showResendVerificationBlock: false
        });
    }

    handleDialogClose() {
        this.setState({ dialogOpen: false });
    }

    render() {
        const { formData, formErrors, showPassword, showResendVerificationBlock, onSuccessDialogOpen, actionType, requestId, dialogOpen } = this.state;
        const { isLoading, verifyOtpLoading, resendVerficationLoading, reVerifySuccess, classes } = this.props;

        return (
            <React.Fragment>
                <Grid container spacing={3} className={classes.form}>
                    <Grid item xs={12}>
                        <form noValidate onSubmit={this.handleLogin}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <FormInput
                                        required
                                        error={formErrors["username"] ? true : false}
                                        helperText={formErrors["username"]}
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        label="Email Address"
                                        onChange={this.handleChange}
                                    />

                                    <FormInput
                                        required
                                        error={formErrors["password"] ? true : false}
                                        helperText={formErrors["password"]}
                                        type={showPassword ? "text" : "password"}
                                        value={formData.password}
                                        name="password"
                                        label="Password"
                                        onChange={this.handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="Toggle password show" onClick={this.handleTogglePasswordVisibility}>
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>

                                {showResendVerificationBlock ? (
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} justify="space-between">
                                            <Grid item md={9} xs={12}>
                                                {resendVerficationLoading ? (
                                                    <Button fullWidth color="primary" variant="contained" className="dark_blue_btn btn">
                                                        <CircularProgress size={24} style={{ color: "#FFF" }} />
                                                    </Button>
                                                ) : (
                                                    <Button fullWidth color="primary" variant="contained" className="dark_blue_btn btn" onClick={this.handleResendVerification}>
                                                        Resend Verification Email
                                                    </Button>
                                                )}
                                            </Grid>

                                            <Grid item container md={3} xs={12} justify="center">
                                                <Button className="btn" variant="contained" onClick={this.handleHideResendVerificationBlock}>
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid item xs={12}>
                                        <Grid container justify="center">
                                            <Grid item md={12} sm={9} xs={12}>
                                                {isLoading ? (
                                                    <Button fullWidth type="button" className="btn" color="secondary" variant="contained">
                                                        <CircularProgress size={24} style={{ color: "#FFF" }} />
                                                    </Button>
                                                ) : (
                                                    <Button fullWidth type="submit" className="btn" color="secondary" variant="contained">
                                                        Log In
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="center">
                            <Typography align="center" className={classes.txtSm}>
                                Forgot password?{" "}
                                <Link component={RouterLink} to="/reset-password" className={classes.txtLink}>
                                    Reset here
                                </Link>
                            </Typography>
                        </Grid>
                    </Grid>

                    <SuccessReverifyModal message={reVerifySuccess} onClose={this.handleOnSuccessDialogClose} open={onSuccessDialogOpen} />

                    <DialogBox
                        maxWidth={this.state.dialogWidth}
                        open={dialogOpen}
                        scope={true}
                        onClose={this.handleDialogClose}
                        ariaLabel="auth-user-title"
                        ariaDesc="auth-user-content"
                    >
                        <DialogTitle id="auth-user-title" className="mouse_move">{actionType || ' '}</DialogTitle>
                        <DialogContent dividers id="auth-user-content">
                            {
                                actionType === 'Change Password' &&
                                <ChangePassword closeDialog={this.handleDialogClose} onSuccess={this.handleNavigateToDashboard} />
                            }
                            {
                                actionType === 'Enter OTP' &&
                                <OtpForm action='login' requestId={requestId} isLoading={verifyOtpLoading} verifyAction={this.handleVerifyOtp} resendAction={this.handleResendOtp} />
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleDialogClose}>Close</Button>
                        </DialogActions>
                    </DialogBox>
                </Grid>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ rxAuth }) {
    return {
        isLoading: rxAuth.authLoading,
        authError: rxAuth.authError,
        authUser: rxAuth.authUser,

        verifyOtpLoading: rxAuth.verifyOtpLoading,
        verifyOtpError: rxAuth.verifyOtpError,

        resendOtpSucccess: rxAuth.resendOtpSucccess,
        resendOtpLoading: rxAuth.resendOtpLoading,
        resendOtpError: rxAuth.resendOtpError,

        resendVerficationLoading: rxAuth.resendVerficationLoading,
        reVerifySuccess: rxAuth.resendVerificationSuccess,
        reVerifyError: rxAuth.resendVerificationError,
    };
}

export default connect(mapStateToProps, {
    verifyOtp,
    resendOtp,
    authenticateUser,
    resendVerfication
})(withSnackbar(LoginForm));
